import { VueConstructor } from "vue";
import helpers from "./helpers";

export const UIHelper = {
  install(Vue: VueConstructor) {
    // Vue.prototype.helpers = helpers;
    Vue.prototype.$helpers = helpers;
  }
};
